import { css } from '@emotion/react';

import generateEmotionClasses from '@core/utils/generateEmotionClasses';

export const classes = generateEmotionClasses('Table', ['scrollWrapper']);

const getTableCss = ({
  maxWidth,
  maxHeight,
}: {
  maxWidth?: string;
  maxHeight?: string;
}) => css`
  max-width: ${maxWidth || '100%'};
  margin: 0;

  .${classes.scrollWrapper} {
    max-height: ${maxHeight || '100%'};
    border: 1px solid var(--cds-color-neutral-stroke-primary-weak);
    border-bottom: none;
    border-top-left-radius: var(--cds-border-radius-100);
    border-top-right-radius: var(--cds-border-radius-100);
    overflow-x: auto;
    position: relative;

    table {
      border-radius: var(--cds-border-radius-100);
      border-collapse: collapse;
      table-layout: fixed;
      width: auto;
      min-width: 100%;
    }
  }
`;

export default getTableCss;
